import { render, staticRenderFns } from "./setViceGoods.vue?vue&type=template&id=58f0083e&scoped=true&"
import script from "./setViceGoods.vue?vue&type=script&lang=js&"
export * from "./setViceGoods.vue?vue&type=script&lang=js&"
import style0 from "./setViceGoods.vue?vue&type=style&index=0&id=58f0083e&lang=less&scoped=true&"
import style1 from "./setViceGoods.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f0083e",
  null
  
)

component.options.__file = "setViceGoods.vue"
export default component.exports